<div class="login-page">
  <app-topnav [pageName]="pageName"></app-topnav>

  <div class="container">
    <div class="content" role="main">
      <div class="cmha-dashboard">
        <div class="participant-banner bb-coached-color">
          <div class="container my-training__banner">
            <div class="my-training__banner-text">
              <h2>My Training</h2>
              <span class="my-training__banner-intro">
                Rewatch the role training videos assigned to you at any time.
              </span>
            </div>

            @if (courses.length > 0) {
              <div class="my-training__progress" aria-label="Training progress">
                <div class="my-training__progress-head">
                  <span class="my-training__progress-count">{{ acknowledgedCount }} of {{ courses.length }}</span>
                  <span>acknowledged</span>
                </div>
                <div class="my-training__progress-track" role="progressbar"
                  [attr.aria-valuenow]="progressPercent" aria-valuemin="0" aria-valuemax="100">
                  <div class="my-training__progress-fill" [style.width.%]="progressPercent"></div>
                </div>
                @if (requiredRemaining > 0) {
                  <span class="my-training__progress-note">{{ requiredRemaining }} required still to acknowledge</span>
                } @else if (acknowledgedCount === courses.length) {
                  <span class="my-training__progress-note">All training complete</span>
                }
              </div>
            }
          </div>
        </div>
        <div class="h-30"></div>

        <div class="container">
          @if (isLoading && courses.length === 0) {
            <div class="my-training" aria-busy="true">
              <div class="my-training__card">
                @for (i of [1, 2, 3]; track i) {
                  <div class="my-training__skeleton my-training__skeleton--row"></div>
                }
              </div>
              <div class="my-training__card">
                <div class="my-training__skeleton my-training__skeleton--player"></div>
                <div class="my-training__skeleton my-training__skeleton--line"></div>
              </div>
            </div>
          } @else if (courses.length === 0) {
            <div class="my-training__card my-training__empty">
              <mat-icon class="my-training__empty-icon">video_library</mat-icon>
              <h3>No training yet</h3>
              <p>There is no role training assigned to you. When new training is added for your role, it will appear here.</p>
            </div>
          } @else {
            <div class="my-training">
              <aside class="my-training__card my-training__sidebar">
                <h3 class="my-training__sidebar-title">
                  Videos <span class="my-training__sidebar-count">{{ courses.length }}</span>
                </h3>
                <ul class="my-training__list" aria-label="Training videos">
                  @for (course of courses; track course.id) {
                    <li>
                      <button
                        type="button"
                        class="my-training__item"
                        [class.my-training__item--active]="current?.id === course.id"
                        [attr.aria-current]="current?.id === course.id ? 'true' : null"
                        (click)="select(course, true)">
                        <mat-icon
                          class="my-training__item-icon"
                          [class.my-training__item-icon--done]="course.isAcknowledged"
                          aria-hidden="true">
                          {{ course.isAcknowledged ? 'check_circle' : 'play_circle' }}
                        </mat-icon>
                        <span class="my-training__item-body">
                          <span class="my-training__item-title">{{ course.title }}</span>
                          <span class="my-training__item-meta">
                            {{ course.roleName }} · {{ course.isMandatory ? 'Required' : 'Optional' }}
                          </span>
                          <span class="my-training__badge"
                            [class.my-training__badge--done]="course.isAcknowledged"
                            [class.my-training__badge--todo]="!course.isAcknowledged">
                            {{ course.isAcknowledged ? 'Acknowledged' : 'Not acknowledged' }}
                          </span>
                        </span>
                      </button>
                    </li>
                  }
                </ul>
              </aside>

              @if (current) {
                <section class="my-training__card my-training__detail" #detail>
                  <div class="my-training__player" aria-label="Training video">
                    @if ((embedType === 'youtube' || embedType === 'vimeo' || embedType === 'iframe') && safeEmbedUrl) {
                      <iframe
                        [src]="safeEmbedUrl"
                        title="Role training video"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
                    }
                    @if (embedType === 'video' && videoSrc) {
                      <video [src]="videoSrc" controls></video>
                    }
                  </div>

                  <div class="my-training__detail-body">
                    <div class="my-training__chips">
                      <span class="my-training__chip">{{ current.roleName }}</span>
                      <span class="my-training__chip" [class.my-training__chip--required]="current.isMandatory">
                        {{ current.isMandatory ? 'Required' : 'Optional' }}
                      </span>
                      <span class="my-training__chip-position">Video {{ currentIndex + 1 }} of {{ courses.length }}</span>
                    </div>

                    <h3 class="my-training__course-title">{{ current.title }}</h3>
                    @if (current.description) {
                      <p class="my-training__description">{{ current.description }}</p>
                    }

                    @if (current.isAcknowledged) {
                      <div class="my-training__status my-training__status--done">
                        <mat-icon aria-hidden="true">verified</mat-icon>
                        <span>
                          You acknowledged this training
                          @if (current.acknowledgedOnUtc) {
                            on <strong>{{ current.acknowledgedOnUtc | date:'MMM d, y' }}</strong>
                          }.
                        </span>
                      </div>
                    } @else {
                      <div class="my-training__status my-training__status--todo">
                        <mat-checkbox [(ngModel)]="acknowledged" name="acknowledged">
                          I acknowledge that I have watched and completed this training.
                        </mat-checkbox>
                        <div class="form-buttons my-training__ack-actions">
                          <button
                            class="submit-form-button"
                            type="button"
                            [disabled]="!acknowledged || isSubmitting"
                            (click)="submit()">
                            {{ isSubmitting ? 'Saving…' : 'Acknowledge' }}
                          </button>
                        </div>
                      </div>
                    }

                    @if (courses.length > 1) {
                      <div class="my-training__pager">
                        <button type="button" class="my-training__pager-btn" [disabled]="currentIndex <= 0" (click)="goTo(-1)">
                          <mat-icon aria-hidden="true">chevron_left</mat-icon>
                          Previous
                        </button>
                        <button type="button" class="my-training__pager-btn" [disabled]="currentIndex >= courses.length - 1" (click)="goTo(1)">
                          Next
                          <mat-icon aria-hidden="true">chevron_right</mat-icon>
                        </button>
                      </div>
                    }
                  </div>
                </section>
              }
            </div>
          }
        </div>

        <div class="h-30"></div>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</div>
